import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptCommonUserModule } from "@common/user/adapt-common-user.module";
import { EditorViewDirective } from "./editor-view.directive";
import { MentionPersonComponent } from "./mention-person/mention-person.component";

@NgModule({
    imports: [CommonModule, AdaptCommonUserModule],
    exports: [EditorViewDirective, MentionPersonComponent],
    declarations: [EditorViewDirective, MentionPersonComponent],
})
export class AdaptEditorViewModule { }
